module.exports = __webpack_public_path__ + "static/media/admin-2.1433d4a1.jpg";